import styled from 'styled-components';

const VisuallyHidden = styled('span')`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;

VisuallyHidden.displayName = 'VisuallyHidden';

export default VisuallyHidden;
